(function () {
  'use strict';

  /* Mobile drawer */
  var drawer = document.getElementById('MobileDrawer');
  var openBtn = document.querySelector('[data-drawer-open]');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.hidden = !open;
    if (openBtn) openBtn.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) { var c = drawer.querySelector('[data-drawer-close].icon-button'); if (c) c.focus(); }
    else if (openBtn) openBtn.focus();
  }
  if (openBtn) openBtn.addEventListener('click', function () { setDrawer(true); });
  document.querySelectorAll('[data-drawer-close]').forEach(function (el) {
    el.addEventListener('click', function () { setDrawer(false); });
  });

  /* Header search */
  var searchBtn = document.querySelector('[data-search-toggle]');
  var searchBox = document.getElementById('HeaderSearch');
  function setSearch(open) {
    if (!searchBox || !searchBtn) return;
    searchBox.hidden = !open;
    searchBtn.setAttribute('aria-expanded', String(open));
    if (open) { var i = searchBox.querySelector('input[type="search"]'); if (i) i.focus(); }
  }
  if (searchBtn) searchBtn.addEventListener('click', function () { setSearch(searchBox.hidden); });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && !drawer.hidden) setDrawer(false);
    else if (searchBox && !searchBox.hidden) { setSearch(false); searchBtn.focus(); }
  });

  /* Product page: gallery, variants, quantity */
  document.querySelectorAll('[data-product-section]').forEach(function (root) {
    var form = root.querySelector('form.product-form');
    var dataEl = root.querySelector('[data-variants]');
    var variants = [];
    try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) { variants = []; }

    function showMedia(id) {
      var found = false;
      root.querySelectorAll('.gallery__item').forEach(function (f) {
        var on = f.getAttribute('data-media-id') === String(id);
        if (on) found = true;
      });
      if (!found) return;
      root.querySelectorAll('.gallery__item').forEach(function (f) {
        f.classList.toggle('is-active', f.getAttribute('data-media-id') === String(id));
      });
      root.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(id));
      });
    }
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); });
    });

    if (form) {
      var idInput = form.querySelector('[data-variant-id]');
      var addBtn = root.querySelector('[data-add-button]');
      var priceCur = root.querySelector('[data-price-current]');
      var priceCmp = root.querySelector('[data-price-compare]');
      var priceWrap = root.querySelector('[data-price]');

      form.addEventListener('change', function (e) {
        if (!e.target.closest('.option[data-option-index]')) return;
        var chosen = [];
        form.querySelectorAll('.option[data-option-index]').forEach(function (fs) {
          var checked = fs.querySelector('input:checked');
          chosen.push(checked ? checked.value : null);
        });
        var match = variants.filter(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        })[0];
        if (!match) {
          addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return;
        }
        idInput.value = match.id;
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to cart' : 'Sold out';
        priceCur.textContent = match.price;
        if (match.compare) { priceCmp.textContent = match.compare; priceCmp.hidden = false; priceWrap.classList.add('price--sale'); }
        else { priceCmp.hidden = true; priceWrap.classList.remove('price--sale'); }
        var stock = root.querySelector('[data-stock]');
        if (stock) { stock.textContent = match.available ? 'In stock' : 'Out of stock'; stock.className = 'stock-badge ' + (match.available ? 'stock-badge--in' : 'stock-badge--out'); }
        var alt = root.querySelector('[data-alternates]'); if (alt) alt.hidden = match.available;
        var bn = root.querySelector('[data-buy-now]'); if (bn) bn.disabled = !match.available;
        var skuWrap = root.querySelector('[data-sku-wrap]'); var skuEl = root.querySelector('[data-sku]');
        if (skuWrap && skuEl) { skuEl.textContent = match.sku || ''; skuWrap.hidden = !match.sku; }
        if (match.media) showMedia(match.media);
        if (window.history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url);
        }
      });

      var rt = form.querySelector('[data-return-to]');
      var buy = form.querySelector('[data-buy-now]');
      if (rt && addBtn) addBtn.addEventListener('click', function () { rt.value = ''; });
      if (rt && buy) buy.addEventListener('click', function () { rt.value = '/checkout'; });

      var qty = form.querySelector('input[name="quantity"]');
      var minus = form.querySelector('[data-qty-minus]');
      var plus = form.querySelector('[data-qty-plus]');
      if (qty && minus && plus) {
        minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
        plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
      }
    }
  });
})();

/* Track order */
(function () {
  document.querySelectorAll('[data-track-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var sel = form.querySelector('[data-track-courier]');
      var input = form.querySelector('[data-track-id]');
      var err = form.querySelector('[data-track-error]');
      var id = input.value.trim();
      var tpl = sel.value.trim();
      function fail(msg) { err.textContent = msg; err.hidden = false; }
      err.hidden = true;
      if (!id) return fail('Enter your tracking ID.');
      if (!/^https:\/\//i.test(tpl) || tpl.indexOf('{tracking}') === -1) {
        return fail('Tracking is not set up for this courier yet. Please contact us.');
      }
      window.open(tpl.replace('{tracking}', encodeURIComponent(id)), '_blank', 'noopener');
    });
  });
})();

/* Show more / less */
(function () {
  document.querySelectorAll('[data-expand]').forEach(function (box) {
    var btn = box.querySelector('[data-expand-btn]');
    var body = box.querySelector('.expand__body');
    if (!btn || !body) return;
    if (body.scrollHeight <= body.clientHeight + 4) { btn.hidden = true; box.classList.add('is-open'); return; }
    btn.addEventListener('click', function () {
      var open = box.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
      btn.textContent = open ? 'Show less' : 'Show more';
    });
  });
})();

/* Same generic name: other products that share a "generic:Name" tag */
(function () {
  document.querySelectorAll('[data-same-generic]').forEach(function (box) {
    var url = box.getAttribute('data-url');
    var ex = box.getAttribute('data-exclude');
    if (!url || !window.fetch) return;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var keep = [];
        tmp.querySelectorAll('li[data-handle]').forEach(function (li) {
          if (li.getAttribute('data-handle') !== ex) keep.push(li);
        });
        if (!keep.length) return;
        var ul = document.createElement('ul');
        ul.className = 'product-grid product-grid--4';
        ul.setAttribute('role', 'list');
        keep.slice(0, 4).forEach(function (li) { ul.appendChild(li); });
        box.querySelector('[data-same-generic-body]').appendChild(ul);
        box.hidden = false;
      })
      .catch(function () {});
  });
})();


/* App download bar: close for this visit */
(function () {
  var bar = document.querySelector('[data-app-bar]');
  if (!bar) return;
  try { if (window.sessionStorage.getItem('nuvia-app-bar') === '1') { bar.hidden = true; return; } } catch (e) {}
  var btn = bar.querySelector('[data-app-bar-close]');
  if (btn) btn.addEventListener('click', function () {
    bar.hidden = true;
    try { window.sessionStorage.setItem('nuvia-app-bar', '1'); } catch (e) {}
  });
})();
